import { css } from '@emotion/css';

export const menuBox = css`
  top: 5.6rem;
  width: 34rem;
`;

export const iconButton = css`
  width: 2rem;
  height: 2rem;
`;
